
const Option = (props) => {
    props = props.data;
    return (
        <option value={props.value}>{props.label}</option>
    );
}

export default Option;